import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import PageTitle from "../../../../components/partials/PageTitle";
import { CSVLink } from "react-csv";
import excel from "../../../../assets/images/img-icons/excel.png";
import pdf from "../../../../assets/images/img-icons/pdf.png";
import { getCustomerPolicyInfo } from "../../../../redux/slice/report/reportSlice";
import ReportFilter from "./ReportFilter";
import { useReactToPrint } from "react-to-print";
import { useNavigate } from "react-router-dom";

const CustomerPolicyInformation = () => {
  const [filterData, setFilterData] = useState();
  const [filteredItem, setFilteredItem] = useState(false);

  const CCPdfRef = useRef();

  const { user } = useSelector((state) => state.auth);
  const { customerOverviewData } = useSelector((state) => state.report);
  const { user_permissions } = useSelector((state) => state?.auth?.user);

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const breadcrumb = {
    from: {
      title: "Policy Report",
      link: "/admin/reports/policy-report",
    },
    current: {
      title: "Policy Information",
      link: null,
    },
  };

  const processedData = customerOverviewData?.map((row) => {
    const fullName = `${row.first_name} ${row.last_name}`;
    const agent = `${row.agent_firstname} ${row.agent_lastname}`;

    return { ...row, full_name: fullName, agent }; // Modify status property while keeping the rest
  });

  const headers = [
    { label: "Policy Number", key: "policy_application_number" },
    { label: "Customer ID", key: "customer_id" },
    { label: "Customer Name", key: "full_name" },
    { label: "Policy", key: "policy_name" },
    // { label: "Cover Type", key: "cover_type" },
    // { label: "Sum Insured", key: "sum_insured" },
    { label: "Effective Date", key: "effective_date" },
    { label: "End Date", key: "end_date" },
    { label: "Agent", key: "agent" },
    { label: "Office", key: "office_name" },
  ];

  // print table to pdf
  const generatePDF = useReactToPrint({
    content: () => CCPdfRef.current,
    documentTitle: "Customer Policy Information",
  });

  // Calculate the total premium amount
  const totalPremiumAmount = customerOverviewData?.reduce((total, item) => {
    return total + (parseFloat(item?.total_premium_amount) || 0);
  }, 0);
  const totalSumInsured = customerOverviewData?.reduce((total, item) => {
    return total + (parseFloat(item?.sum_insured) || 0);
  }, 0);

  useEffect(() => {
    if (filteredItem) {
      if (filterData.office_id === "") {
        const updatedFilterData = {
          ...filterData,
          office_id: user?.user?.office_id,
        };
        dispatch(getCustomerPolicyInfo(updatedFilterData));
      } else {
        dispatch(getCustomerPolicyInfo(filterData));
      }
    }
  }, [dispatch, filterData, filteredItem, user?.user?.office_id]);

  useEffect(() => {
    if (
      !user_permissions?.some(
        (permission) => permission.name === "customer report module"
      ) ||
      !user_permissions?.some(
        (permission) => permission.name === "customer policy information report"
      )
    ) {
      navigate("/admin/dashboard");
    }
  }, [navigate, user_permissions]);
  return (
    <>
      {/* page title */}
      <PageTitle title='Policy Information' breadcrumb={breadcrumb} />
      {/* end page title */}
      <div className='row card p-1' style={{ margin: "auto 1px" }}>
        <ReportFilter
          page={"policyInfo"}
          setFilterData={setFilterData}
          setFilteredItem={setFilteredItem}
          filteredItem={filteredItem}
        />
        {customerOverviewData && (
          <div className='row mb-3'>
            <>
              <div className='d-flex justify-content-end align-items-center'>
                <div className=' d-flex align-items-center border '>
                  <span
                    className='bg-info me-2 text-white'
                    style={{ padding: "3px" }}
                  >
                    Export to
                  </span>

                  <span
                    href='#'
                    id='btnExport'
                    className='me-1 cursor-p'
                    title='Export to Pdf'
                    onClick={generatePDF}
                  >
                    <img
                      src={pdf}
                      alt='export-pdf'
                      style={{ height: "25px" }}
                    />
                  </span>
                  {customerOverviewData ? (
                    <CSVLink
                      data={processedData}
                      headers={headers}
                      style={{ fontWeight: "bolder", cursor: "pointer" }}
                      filename='Customer Policy Information'
                    >
                      <span
                        href='#'
                        id='btnExport'
                        className='mr-1'
                        title='Export to Excel'
                      >
                        <img
                          src={excel}
                          alt='export-excel'
                          style={{ height: "25px", marginRight: "5px" }}
                        />
                      </span>
                    </CSVLink>
                  ) : null}
                </div>
              </div>
              <div className='table-responsive'>
                <table
                  className='table table-centered table-striped nowrap w-100 no-footer'
                  ref={CCPdfRef}
                >
                  <thead>
                    <tr>
                      <th
                        className='sorting'
                        tabIndex='0'
                        rowSpan='1'
                        colSpan='1'
                        style={{ width: "100.8px" }}
                        aria-label='Email: activate to sort column ascending'
                      >
                        Policy Number
                      </th>
                      <th
                        className='sorting'
                        tabIndex='0'
                        rowSpan='1'
                        colSpan='1'
                        style={{ width: "100.8px" }}
                        aria-label='Email: activate to sort column ascending'
                      >
                        Customer Id
                      </th>
                      <th
                        className='sorting'
                        tabIndex='0'
                        rowSpan='1'
                        colSpan='1'
                        style={{ width: "150.8px" }}
                        aria-label='Customer: activate to sort column ascending'
                      >
                        Customer Name
                      </th>
                      <th
                        className='sorting'
                        tabIndex='0'
                        rowSpan='1'
                        colSpan='1'
                        style={{ width: "134.8px" }}
                        aria-label='Phone: activate to sort column ascending'
                      >
                        Policy
                      </th>
                      {/* <th
                        className='sorting'
                        tabIndex='0'
                        rowSpan='1'
                        colSpan='1'
                        style={{ width: "124.8px" }}
                        aria-label='Phone: activate to sort column ascending'
                      >
                        Cover Type
                      </th> */}
                      {/* <th
                        className='sorting'
                        tabIndex='0'
                        rowSpan='1'
                        colSpan='1'
                        style={{ width: "120.8px" }}
                        aria-label='Status: activate to sort column ascending'
                      >
                        Sum Insured
                      </th> */}
                      <th
                        className='sorting'
                        tabIndex='0'
                        rowSpan='1'
                        colSpan='1'
                        style={{ width: "120.8px" }}
                        aria-label='Status: activate to sort column ascending'
                      >
                        Total Premium Paid
                      </th>
                      <th
                        className='sorting'
                        tabIndex='0'
                        rowSpan='1'
                        colSpan='1'
                        style={{ width: "120.8px" }}
                        aria-label='Status: activate to sort column ascending'
                      >
                        Effective Date
                      </th>
                      <th
                        className='sorting'
                        tabIndex='0'
                        rowSpan='1'
                        colSpan='1'
                        style={{ width: "120.8px" }}
                        aria-label='Status: activate to sort column ascending'
                      >
                        End Date
                      </th>
                      <th
                        className='sorting'
                        tabIndex='0'
                        rowSpan='1'
                        colSpan='1'
                        style={{ width: "120.8px" }}
                        aria-label='Status: activate to sort column ascending'
                      >
                        Agent
                      </th>
                      <th
                        className='sorting'
                        tabIndex='0'
                        rowSpan='1'
                        colSpan='1'
                        style={{ width: "120.8px" }}
                        aria-label='Status: activate to sort column ascending'
                      >
                        Office
                      </th>
                    </tr>
                  </thead>
                  {customerOverviewData?.length ? (
                    <tbody>
                      {customerOverviewData?.map((item, i) => (
                        <tr key={i}>
                          <td className='text-dark'>
                            {item?.policy_application_number}
                          </td>
                          <td className='text-dark'>{item?.customer_id}</td>
                          <td className='table-user'>
                            <span className='text-body fw-semibold'>
                              {item?.first_name} {item?.last_name}
                            </span>
                          </td>
                          <td className='table-user'>{item?.policy_name}</td>
                          {/* <td className='table-user'>{item?.cover_type}</td>
                          <td className='table-user'>{item?.sum_insured}</td> */}
                          <td className='table-user'>{item?.total_premium_amount}</td>
                          <td className='table-user'>{item?.effective_date}</td>
                          <td>{item?.end_date}</td>
                          <td>
                            {item?.agent_firstname + " "}
                            {item?.agent_lastname}
                          </td>
                          <td>{item?.office_name}</td>
                        </tr>
                      ))}
                      <tr>
                        <td colSpan="5" className="text-end fw-bold">
                          Total:
                        </td>
                        <td className="fw-bold">{totalSumInsured.toLocaleString(2)}</td>
                        <td className="fw-bold">{totalPremiumAmount.toLocaleString(2)}</td>
                        <td colSpan="4"></td>
                      </tr>
                    </tbody>
                  ) : null}
                </table>
                {customerOverviewData?.length < 1 ? (
                  <h5 className='alert alert-info'>No result found!</h5>
                ) : null}
              </div>
            </>
          </div>
        )}
      </div>
    </>
  );
};

export default CustomerPolicyInformation;
